module.exports = "<g id=\"underground_mining\">\n\t<path fill=\"#FFFFFF\" d=\"M7.6-16.3c0-4.2-3.4-7.6-7.6-7.6s-7.6,3.4-7.6,7.6c0,1.4,0.7,3.3,1.4,4.6L-0.1,0l6.2-11.7\n\t\tC7.2-13.5,7.6-14.5,7.6-16.3\"/>\n\t<path fill=\"none\" stroke=\"#747373\" stroke-miterlimit=\"10\" d=\"M7.6-16.3c0-4.2-3.4-7.6-7.6-7.6s-7.6,3.4-7.6,7.6\n\t\tc0,1.4,0.7,3.3,1.4,4.6L-0.1,0l6.2-11.7C7.2-13.5,7.6-14.5,7.6-16.3\"/>\n\t<path fill=\"#747373\" d=\"M0-12.5c2,0,3.6-1.6,3.6-3.6S2-19.6,0-19.6s-3.6,1.6-3.6,3.6S-2-12.5,0-12.5\"/>\n</g>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/map/marker.svg
 ** module id = 36
 ** module chunks = 0
 **/